<div class="footer-bg mb-4 mt-4">
    <div class="container">
        <div class="row mr-fag">
            <div class="col-md-6 col-xs-12">
                <h3 class="mb-4">Frequently Asked Questions (FAQ)</h3>

                <div class="row">
                    <div class="col-md-3 col-xs-4 faq-container" (click)="onActiveFaq(0)">
                        <img *ngIf="activeFaq == 0" src="assets/faq/active/presumptive.svg" alt="Presumptive"/>
                        <img *ngIf="activeFaq !== 0" src="assets/faq/none/presumptive.svg" alt="Presumptive"/>
                    </div>

                    <div class="col-md-3 col-xs-4 faq-container" (click)="onActiveFaq(1)">
                        <img *ngIf="activeFaq == 1" src="assets/faq/active/duties.svg" alt="Duties"/>
                        <img *ngIf="activeFaq !== 1" src="assets/faq/none/duties.svg" alt="Duties"/>
                    </div>

                    <div class="col-md-3 col-xs-4 faq-container" (click)="onActiveFaq(2)">
                        <img *ngIf="activeFaq == 2" src="assets/faq/active/levies.svg" alt="Levies"/>
                        <img *ngIf="activeFaq !== 2" src="assets/faq/none/levies.svg" alt="Levies"/>
                    </div>

                    <div class="col-md-3 col-xs-4 faq-container" (click)="onActiveFaq(3)">
                        <img *ngIf="activeFaq == 3" src="assets/faq/active/taxes.svg" alt="Taxes"/>
                        <img *ngIf="activeFaq !== 3" src="assets/faq/none/taxes.svg" alt="Taxes"/>
                    </div>

                    <div class="col-md-3 col-xs-4 faq-container" (click)="onActiveFaq(4)">
                        <img *ngIf="activeFaq == 4" src="assets/faq/active/mda.svg" alt="MDA"/>
                        <img *ngIf="activeFaq !== 4" src="assets/faq/none/mda.svg" alt="MDA"/>
                    </div>

                    <div class="col-md-3 col-xs-4 faq-container" (click)="onActiveFaq(5)">
                        <img *ngIf="activeFaq == 5" src="assets/faq/active/onLicences.svg" alt="onLicences"/>
                        <img *ngIf="activeFaq !== 5" src="assets/faq/none/onLicences.svg" alt="onLicences"/>
                    </div>

                    <div class="col-md-3 col-xs-4 faq-container" (click)="onActiveFaq(6)">
                        <img *ngIf="activeFaq == 6" src="assets/faq/active/permits.svg" alt="Permits"/>
                        <img *ngIf="activeFaq !== 6" src="assets/faq/none/permits.svg" alt="Permits"/>
                    </div>

                    <div class="col-md-3 col-xs-4 faq-container" (click)="onActiveFaq(7)">
                        <img *ngIf="activeFaq == 7" src="assets/faq/active/penalties.svg" alt="Penalty"/>
                        <img *ngIf="activeFaq !== 7" src="assets/faq/none/penalties.svg" alt="Penalty"/>
                    </div>

                </div>
            </div>
            <div class="col-md-6 col-xs-12 mt-4">
                <div class="example-accordion mt-3 p-0">
                    <mat-accordion style="padding: 0 !important;">
                        <mat-expansion-panel style="margin-bottom: 7px !important;background: #eee;padding: 0" *ngFor="let item of faqArray[activeFaq]?.data">
                            <mat-expansion-panel-header>
                                <mat-panel-title style="padding: 0 !important;">
                                    <strong style="color: #444">{{ item.title }}</strong>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div style="background: #fff !important;display: flex;padding: 20px;border-radius: 4px">
                                <p>{{ item.description }}</p>
                            </div>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
                <!--<div class="display-window">
                    <h6><b>{{faqArray[activeFaq].head}}</b></h6>
                    <p style="font-size: 18px">{{faqArray[activeFaq].title}}</p><br />
                    {{faqArray[activeFaq].description}}<br />
                </div>-->
            </div>
        </div>
    </div>
</div>
